export default {
    cn: {
        profitShareView: {
            title: '利润分成设定',
            account_setting: '账号设定',
            profit_report: '分成报表',
            list: [
                { text: '利润分成报表', link: '/profit/shareReport' },
                { text: '已计算版本报表', link: '/profit/versionReport' }
            ]
        }
    },
    hk: {
        profitShareView: {
            title: '利潤分成設定',
            account_setting: '賬號設定',
            profit_report: '分成報表',
            list: [
                { text: '利潤分成報表', link: '/profit/shareReport' },
                { text: '已計算版本報表', link: '/profit/versionReport' }
            ]
        }
    },
    en: {
        profitShareView: {
            title: 'Profit Sahre Setting',
            account_setting: 'Account Setting',
            profit_report: 'Profit Share Report',
            list: [
                { text: 'Profit Share Report', link: '/profit/shareReport' },
                { text: 'Version Report', link: '/profit/versionReport' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/ProfitShareSetting/profitShareView.js